import { LanguageCode } from './language.model';

export interface Skill {
  language: LanguageCode;
  text: string;
}

export const isSkill = (object: unknown): object is Skill =>
  (object as Skill).language !== undefined && (object as Skill).text !== undefined;
